import { Button, Modal, notification } from 'antd'
import { useState } from 'react'

import { httpClient } from '../../../util/http-client'
import { messages } from '../messages'
import { User } from '../models'
import './resend-temporary-password.scss'

interface ResendTemporaryPasswordProps {
  user: User
  isVisible: boolean
  onClose: () => void
  onSuccess: () => void
}

export const ResendTemporaryPasswordModal = ({ user, isVisible, onClose, onSuccess }: ResendTemporaryPasswordProps) => {
  const [isResending, setIsResending] = useState(false)

  const onResend = async (email: string) => {
    setIsResending(true)

    try {
      await httpClient('/auth/resend-temporary-password', { method: 'POST', data: { email } })
      notification.success({ message: messages.common.success, description: messages.user.resendPassword })
      onSuccess()
    } catch (error) {
      notification.error({
        message: messages.common.error,
        description: messages.user.resendPasswordError,
      })
    } finally {
      setIsResending(false)
    }
  }

  return (
    <Modal
      title="Re-send temporary password"
      onCancel={onClose}
      open={isVisible}
      className="resend-modal-message"
      footer={[
        <div className="footer">
          <Button key="back" onClick={onClose}>
            Cancel
          </Button>
          <Button onClick={() => onResend(user.email)} disabled={isResending} loading={isResending} type="primary">
            Re-send temporary password
          </Button>
        </div>,
      ]}
    >
      <div className="resend-message">
        <p>Are you sure that you want to re-send a temporary password to this user?</p>
        <p>- User E-mail: {user?.email}</p>
        <p></p>
        <p className="resend-message-warning">
          A temporary password can only be sent if the user has not yet set a permanent password. If the user has
          already set a permanent password, please suggest them to reset their password through the "Forgot my password"
          flow.
        </p>
      </div>
    </Modal>
  )
}
